<template>
  <div class="sample-info-wrapper">
    <span class="view-detail-btn" @click="visible = true">
      <i v-html="viewDetailIcon" class="view_icon"></i>查看详情
    </span>

    <el-dialog
        title="分组样本信息"
        :visible.sync="visible"
        width="1150px"
        append-to-body
        custom-class="sample-group-dialog"
    >
      <div v-if="leftGroups||rightGroups" class="sampleGroupCardContainer">
        <one-pick-more key="rnaSampleName" class="sampleGroupCard" :title="title[0]" :showData="leftGroups"
                       :descriptions-style="descriptionsStylerna"></one-pick-more>
        <one-pick-more key="metSampleName" class="sampleGroupCard" :title="title[1]" :showData="rightGroups"
                       :descriptions-style="descriptionsStylemet"></one-pick-more>
      </div>
      <div v-else class="empty-tip"><img src="images/empty.png"></img></div>

    </el-dialog>
  </div>
</template>

<script>
import {viewDetailIcon} from "@/utils/iconUtils";
import OnePickMore from "@/components/project/transMetabo/onePickMore.vue";

export default {
  name: "SampleGroupDetail",
  components: {OnePickMore},
  props: {
    leftGroups: {type: Array, default: () => []},
    rightGroups: {type: Array, default: () => []},
    title: {
      type: Array,
      default: ['转录组','代谢组']
    },
  },
  data() {
    return {
      visible: false,
      viewDetailIcon: viewDetailIcon,
      descriptionsStylerna: {
        'groupLableColor': '#4d79b4',
        // 'labelBackgroundColor':'#f6f9ff'
      },
      descriptionsStylemet: {
        'groupLableColor': '#54a192',
        // 'labelBackgroundColor':'rgba(241,252,248,0.94)'
      },
    };
  },
  methods: {},
};
</script>

<style scoped>
/deep/ .sample-group-dialog .el-dialog__body {
  padding-top: 16px !important;
}

.view-detail-btn {
  cursor: pointer;
  color: rgb(53, 110, 169);
  font-size: 13px;
  margin-left: 3px;
  transition: color 0.2s;
}

.view-detail-btn:hover {
  color: #66b1ff;
}

.sampleGroupCardContainer {
  display: flex;
  gap: 20px;
}

.sampleGroupCard {
  border: 1px solid #eeeeee;
  width: 48%;
  background-color: white;
  border-radius: 5px;
}

.rna-color {
  color: #409eff;
  //color: #66c03b;
}

.met-color {
  color: #259893;
  //color: #66c03b;
}

.panel {
  border: 1px solid #f0f0f0;
  border-radius: 8px;
  overflow: hidden;
  background: #fff;
}

.panel-header {
  padding: 12px 16px;
  font-size: 14px;
  font-weight: 600;
  color: #5c5e5e;
  display: flex;
  align-items: center;
  gap: 6px;
}

.rna-panel .panel-header {
  background-color: #eaf3fe;
  background-color: rgba(234, 243, 254, 0.68);
  //box-shadow: 1px 1px 2px rgb(87, 170, 254);

}

.met-panel .panel-header {
  //border-bottom: 0px rgba(65, 169, 164, 0.98) solid;
  //box-shadow: 1px 1px 2px rgba(93, 187, 183, 0.98);
  background-color: #e6f8f7;
  background-color: rgba(230, 248, 247, 0.67);
}

.panel-body {
  padding: 14px;
  max-height: 450px;
  overflow-y: auto;
}

.panel-body::-webkit-scrollbar {
  width: 5px;
}

.panel-body::-webkit-scrollbar-thumb {
  background: #dcdfe6;
  border-radius: 3px;
}

.group-card {
  margin-bottom: 14px;
  padding: 10px 12px;
  background: #fafbfc;
  border-radius: 6px;
  border: 1px solid #f2f3f5;
  box-shadow: 1px 1px 1px rgb(236, 236, 236);
}

.group-card:last-child {
  margin-bottom: 0;
}

.group-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 10px;
}

.group-name {
  font-size: 13px;
  font-weight: 600;
  //color: #303133;
  //color: #4d79b4;
}

.met-panel .group-name {
  color: #54a192;
}

.rna-panel .group-name {

  color: #4d79b4;
}

.group-count {
  font-size: 12px;
  color: #909399;
}

.inline-sample-info {
  display: flex;

}

.sample-label {
  font-size: 12px;
  color: #909399;
  margin-bottom: 6px;
  font-weight: 400;
  width: 50px;
}

.sample-tags {
  flex: 1;
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  align-items: center;
}

.sample-tag {
  margin-left: 5px;
  //font-size: 12px;
  //padding: 2px 10px;
  //border-radius: 4px;
  //white-space: nowrap;
  //display: inline-block;
  //line-height: 20px;
}

/deep/ .sample-tags .el-tag.el-tag--info {
  background-color: #ffffff !important;
  color: #5e5d5d;
}

.rna-tag {
  //background: #ecf5ff;
  //color: #409eff;
  //border: 1px solid #d9ecff;
}

.met-tag {
  //background: #e8faf8;
  //color: #2db7b0;
  //border: 1px solid #b5f0ec;
  //background: rgba(232, 250, 248, 0.57);
  //color: rgba(76, 154, 150, 0.98);
  //border: 1px solid rgba(130, 208, 203, 0.35);
  //background-color: #f0f9eb;
  //border-color: #e1f3d8;
  //color: #67c23a;
}

.expand-btn {
  font-size: 12px;
  cursor: pointer;
  padding: 2px 8px;
  //border-radius: 4px;
  //background: #f5f7fa;
  //border: 1px dashed #dcdfe6;
  transition: all 0.2s;
  line-height: 20px;
}

.expand-btn:hover {
  background: #eef1f6;
  border-color: #c0c4cc;
}

.empty-tip {
  height: 200px;
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  color: #c0c4cc;
  font-size: 15px;
  padding: 30px 0;
}
.empty-tip img{
  //width: 200px;
  height: 180px;
}

/deep/ .view_icon i {
  margin-right: 0px !important;
  color: rgb(53, 110, 169) !important;
}
</style>
